"use client";

import { useState } from "react";
import Link from "next/link";
import { ChevronDown, ArrowRight, Menu, X } from "lucide-react";

export function Nav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [industriesOpen, setIndustriesOpen] = useState(false);

  const closeMobile = () => {
    setMobileOpen(false);
    setServicesOpen(false);
    setIndustriesOpen(false);
  };

  return (
    <>
      <nav className="fixed top-0 w-full z-50 bg-background/90 backdrop-blur-md border-b">
        <div className="max-w-7xl mx-auto px-4 h-24 flex items-center justify-between">
          <Link href="/" className="flex items-center cursor-pointer" onClick={closeMobile}>
            <div className="flex flex-col">
              <span className="text-2xl font-display font-black tracking-tight text-foreground leading-tight">GBP Experts</span>
              <span className="text-[9px] font-bold tracking-[0.1em] text-muted-foreground uppercase leading-none">Powered by Silver Oak Digital Marketing</span>
            </div>
          </Link>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
            data-testid="button-mobile-menu"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>

          <div className="hidden md:flex items-center gap-8 text-sm font-bold uppercase tracking-wider">
            <div className="relative group">
              <button className="flex items-center gap-1 hover:text-[#4285F4] transition-colors cursor-pointer uppercase tracking-wider">
                Services <ChevronDown className="w-4 h-4" />
              </button>
              <div className="absolute top-full left-0 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
                <div className="w-64 bg-white rounded-xl p-2 shadow-lg border">
                  <Link href="/gbp-management" className="block font-bold uppercase text-xs tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Full GBP Management
                  </Link>
                  <Link href="/optimization" className="block font-bold uppercase text-xs tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Profile Optimization
                  </Link>
                  <Link href="/reputation" className="block font-bold uppercase text-xs tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Reputation Management
                  </Link>
                  <Link href="/reinstatements" className="block font-bold uppercase text-xs tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    GBP Reinstatements
                  </Link>
                  <Link href="/multi-location" className="block font-bold uppercase text-xs tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Multi-Location SEO
                  </Link>
                  <Link href="/map-tracking" className="block font-bold uppercase text-xs tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Map Ranking
                  </Link>
                </div>
              </div>
            </div>

            <div className="relative group">
              <button className="flex items-center gap-1 hover:text-[#4285F4] transition-colors cursor-pointer uppercase tracking-wider">
                Industries <ChevronDown className="w-4 h-4" />
              </button>
              <div className="absolute top-full left-0 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
                <div className="w-56 bg-white rounded-xl p-2 shadow-lg border max-h-[400px] overflow-y-auto">
                  <Link href="/legal" className="block font-bold uppercase text-[10px] tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Law Offices
                  </Link>
                  <Link href="/dental" className="block font-bold uppercase text-[10px] tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Dental Practices
                  </Link>
                  <Link href="/medspa" className="block font-bold uppercase text-[10px] tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Med Spas
                  </Link>
                  <Link href="/plastic-surgery" className="block font-bold uppercase text-[10px] tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Plastic Surgery
                  </Link>
                  <Link href="/home-services" className="block font-bold uppercase text-[10px] tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Home Services
                  </Link>
                  <Link href="/real-estate" className="block font-bold uppercase text-[10px] tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Real Estate
                  </Link>
                  <Link href="/veterinary" className="block font-bold uppercase text-[10px] tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Veterinary
                  </Link>
                  <Link href="/restaurants" className="block font-bold uppercase text-[10px] tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Restaurants
                  </Link>
                  <Link href="/auto-repair" className="block font-bold uppercase text-[10px] tracking-widest p-3 rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">
                    Auto Repair
                  </Link>
                </div>
              </div>
            </div>

            <Link href="/about" className="hover:text-[#4285F4] transition-colors cursor-pointer uppercase tracking-wider">About Us</Link>
            <Link href="/pricing" className="hover:text-[#4285F4] transition-colors cursor-pointer uppercase tracking-wider">Pricing</Link>
            <Link href="/portal" className="hover:text-[#4285F4] transition-colors cursor-pointer uppercase tracking-wider" data-testid="link-client-portal">Client Portal</Link>

            <Link href="/contact" className="inline-flex items-center justify-center rounded-full px-6 h-10 bg-[#4285F4] hover:bg-[#4285F4]/90 text-sm font-bold text-white transition-colors" data-testid="button-get-started">
              Get Started <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-white border-t max-h-[calc(100vh-6rem)] overflow-y-auto">
            <div className="px-4 py-4 space-y-1">
              <div>
                <button
                  className="flex items-center justify-between w-full py-3 px-3 text-sm font-bold uppercase tracking-wider rounded-lg hover:bg-gray-50"
                  onClick={() => setServicesOpen(!servicesOpen)}
                >
                  Services
                  <ChevronDown className={`w-4 h-4 transition-transform ${servicesOpen ? 'rotate-180' : ''}`} />
                </button>
                {servicesOpen && (
                  <div className="ml-3 pl-3 border-l-2 border-[#4285F4]/20 space-y-1">
                    <Link href="/gbp-management" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Full GBP Management</Link>
                    <Link href="/optimization" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Profile Optimization</Link>
                    <Link href="/reputation" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Reputation Management</Link>
                    <Link href="/reinstatements" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">GBP Reinstatements</Link>
                    <Link href="/multi-location" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Multi-Location SEO</Link>
                    <Link href="/map-tracking" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Map Ranking</Link>
                  </div>
                )}
              </div>

              <div>
                <button
                  className="flex items-center justify-between w-full py-3 px-3 text-sm font-bold uppercase tracking-wider rounded-lg hover:bg-gray-50"
                  onClick={() => setIndustriesOpen(!industriesOpen)}
                >
                  Industries
                  <ChevronDown className={`w-4 h-4 transition-transform ${industriesOpen ? 'rotate-180' : ''}`} />
                </button>
                {industriesOpen && (
                  <div className="ml-3 pl-3 border-l-2 border-[#4285F4]/20 space-y-1">
                    <Link href="/legal" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Law Offices</Link>
                    <Link href="/dental" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Dental Practices</Link>
                    <Link href="/medspa" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Med Spas</Link>
                    <Link href="/plastic-surgery" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Plastic Surgery</Link>
                    <Link href="/home-services" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Home Services</Link>
                    <Link href="/real-estate" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Real Estate</Link>
                    <Link href="/veterinary" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Veterinary</Link>
                    <Link href="/restaurants" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Restaurants</Link>
                    <Link href="/auto-repair" onClick={closeMobile} className="block py-2 px-3 text-xs font-bold uppercase tracking-widest rounded-lg hover:bg-[#4285F4]/10 hover:text-[#4285F4]">Auto Repair</Link>
                  </div>
                )}
              </div>

              <Link href="/about" onClick={closeMobile} className="block py-3 px-3 text-sm font-bold uppercase tracking-wider rounded-lg hover:bg-gray-50">About Us</Link>
              <Link href="/pricing" onClick={closeMobile} className="block py-3 px-3 text-sm font-bold uppercase tracking-wider rounded-lg hover:bg-gray-50">Pricing</Link>
              <Link href="/portal" onClick={closeMobile} className="block py-3 px-3 text-sm font-bold uppercase tracking-wider rounded-lg hover:bg-gray-50" data-testid="link-client-portal-mobile">Client Portal</Link>

              <div className="pt-3 border-t">
                <Link href="/contact" onClick={closeMobile} className="flex items-center justify-center rounded-full h-12 bg-[#4285F4] hover:bg-[#4285F4]/90 text-sm font-bold text-white transition-colors" data-testid="button-get-started-mobile">
                  Get Started <ArrowRight className="w-4 h-4 ml-2" />
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>

      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-3 bg-white/90 backdrop-blur-md border-t shadow-lg">
        <Link
          href="/contact"
          className="flex items-center justify-center w-full h-12 rounded-full bg-[#4285F4] hover:bg-[#4285F4]/90 text-white font-bold text-sm transition-colors shadow-md"
          data-testid="button-sticky-cta"
        >
          Book Your Free Consultation <ArrowRight className="w-4 h-4 ml-2" />
        </Link>
      </div>
    </>
  );
}
